@if (show) {
  <div class="backdrop">
    <div class="content center">
      <ng-content></ng-content>
    </div>
    <div class="lds-roller center">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
